"use client";
import { cacheExchange } from "@urql/exchange-graphcache";
import { useSession } from "next-auth/react";
import { useMemo } from "react";
import toast from "react-hot-toast";
import {
  //cacheExchange,
  Provider,
  createClient,
  errorExchange,
  fetchExchange,
  ssrExchange,
  useMutation,
  useQuery,
} from "urql";
import { useUI } from "./context";

const isServer = typeof window === "undefined";

export const UrqlProvider = ({ children, schema }) => {
  const client = useClient(schema);
  return <Provider value={client}>{children}</Provider>;
};

export { ssrExchange, useMutation, useQuery };

export function useClient(schema) {
  // jwt is set to data via backend api setup of next-auth
  // but it is not typed...
  const { data }: { data: any } = useSession();
  const { siteConfig } = useUI();

  return useMemo(() => {
    const { client } = initClient({
      token: data?.jwt,
      schema,
      url: siteConfig.strapi?.graphqlUrl,
    });
    return client;
  }, [data?.jwt]);
}

export function initClient(
  {
    initialState,
    token,
    schema,
    url,
  }: {
    initialState?: any;
    token?: string;
    schema?: any;
    url: string;
  } = { initialState: undefined, url: "" }
) {
  //if (client) return { client, ssrCache };
  // const config =
  //   typeof window === "undefined" ? getSiteConfig() : getClientSiteConfig();
  // const url = config.strapi?.graphqlUrl || "";
  // const fetchOptions = config.urqlFetchOptions;
  const ssrCache = ssrExchange({
    isClient: !isServer,
    initialState: initialState,
  });
  const client = createClient({
    url,
    exchanges: [
      errorExchange({
        onError: (error) => {
          console.log("IRQL - GraphQL Error", error, error?.graphQLErrors);

          if (error?.graphQLErrors) {
            error?.graphQLErrors?.forEach((e) => {
              toast.error(e.message);
            });
          } else {
            toast.error("Network Error - Please try again later");
          }
        },
      }),
      //@ts-ignore
      cacheExchange({
        //@ts-ignore
        schema,
        keys: {
          CategoryContent: (data: any) => data?.categoryId,
          CategoryContentEntityResponse: () => null,
          CategoryContentEntityResponseCollection: () => null,
          Entity: (data: any) => data?.entityId,
          Footer: () => null,
          FooterEntityResponse: () => null,
          HierarchyEntityResponse: () => null,
          Menu: () => null,
          MenuEntityResponse: () => null,
          MenuEntityResponseCollection: () => null,
          MenuItem: () => null,
          MenuItemRelationResponseCollection: () => null,
          Page: () => null,
          PageEntityResponse: () => null,
          PageEntityResponseCollection: () => null,
          PageRelationResponseCollection: () => null,
          PriceFilter: () => null,
          Tag: () => null,
          TagEntityResponseCollection: (data) => null,
          TagRelationResponseCollection: () => null,
          UploadFile: (data: any) => data?.hash,
          UploadFileEntityResponse: () => null,
          UploadFileRelationResponseCollection: () => null,
          Value: (data) => null,
          FaqEntityResponse: (data) => null,
          Faq: () => null,
          ValueEntityResponse: (data: any) => data?.data?.id || null,
          PeopleEntityResponse: () => null,
          Commerce: () => null,
          CommerceEntityResponse: () => null,
          Image: () => null,
          Brand: () => null,
          Breadcrumb: () => null,
          ProductContent: () => null,
          ProductContentEntityResponse: () => null,
          CategoryContentEntity: () => null,
          ProductSpecification: () => null,
          AlternatePath: () => null,
          PropertyList: () => null,
          ProductCrossSelling: () => null,
          CommerceEntity: () => null,
          ComponentCommerceSpecialOffer: () => null,
          UploadFileEntity: () => null,
          PropertyListEntityResponse: () => null,
          PropertyListEntity: () => null,
          ProductConfiguration: () => null,
          ProductConfigurationOption: () => null,
        },
      }),
      ssrCache,
      fetchExchange,
    ],
    fetchOptions: () => {
      return {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
      };
    },
  });
  return { client, ssrCache };
}
